import { render } from "./AlreadyVertifiedView.vue?vue&type=template&id=16b1528d"
import script from "./AlreadyVertifiedView.vue?vue&type=script&lang=js"
export * from "./AlreadyVertifiedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__